export default {
  home: '/',
  accountActivation: '/account-activation/',
  account: '/:org_id/account/',
  login: '/login',
  loginByLink: {
    index: '/login-by-link/',
    sent: '/login-by-link/sent/',
    fail: '/login-by-link/fail/',
    verify: '/login-by-link/verify/:token/',
  },
  auth: {
    verifyLoginByLink: '/auth/login-by-link/verify/:token/',
    verifyResetPassword: '/auth/password-reset/verify/:token/',
  },
  organization: {
    index: 'organization/',
    viewAll: ':org_id/organizations/',
    detail: ':org_id/settings/',
    members: 'organization/:org_id/members/',
    invitations: 'invitations/',
    sharingInvitationVerification:
      'organizations/:org_id/projects/:project_id/verify_invitation/:token/',
    orgInvitationVerification:
      'organizations/:org_id/invitations/:invitation_id/verify/:token',
  },
  projects: {
    index: '/:org_id/projects/',
    detail: '/:org_id/projects/:project_id/',
    model: {
      index: '/:org_id/projects/:project_id/models/',
      detail: '/:org_id/projects/:project_id/models/:model_id/',
      inputTable: {
        index:
          '/:org_id/projects/:project_id/models/:model_id/input-table/:input_table_name/',
      },
      expense: {
        index: '/:org_id/projects/:project_id/models/:model_id/expenses/',
        detail:
          '/:org_id/projects/:project_id/models/:model_id/expenses/:expense_id/',
      },
    },
    expenses: {
      index: '/:org_id/projects/:project_id/expenses/',
      detail: '/:org_id/projects/:project_id/expenses/:expense_id/',
    },
    members: '/:org_id/projects/:project_id/members/',
    dataset: {
      index: '/:org_id/projects/:project_id/datasets/',
      detail: '/:org_id/projects/:project_id/datasets/:dataset_id/',
    },
    actualData: '/:org_id/projects/:project_id/actual-data/',
    settings: '/:org_id/projects/:project_id/settings/',
    create: '/:org_id/projects/create/',
    accessListById: '/:org_id/projects/:project_id/access-list/',
  },
  sharedModelVault: {
    index: '/:org_id/shared-model-vault/',
    detail: '/:org_id/shared-model-vault/:request_id/',
  },
  archivedAssets: {
    index: '/:org_id/archived-assets/',
  },
  resetPassword: {
    index: '/password-reset/',
    sent: '/password-reset/sent/',
    fail: '/password-reset/fail/',
    setPassword: '/password-reset/set-password/',
  },
  changePassword: '/password-change/',
  userManagement: {
    index: '/:org_id/user-management/',
    detail: '/:org_id/user-management/:user_id/',
  },
  audit: '/:org_id/audit/',
};
